import { LoginDto } from "../../model/user/dto/LoginDto";
import { LoginResponseDto } from "../../model/user/dto/LoginResponseDto";

import { AtiraApi } from "../AxiosClient";

export class UserAxios {
  static login(dto: LoginDto) {
    console.log(process.env.REACT_APP_API_URL, dto);
    return AtiraApi.post<LoginResponseDto>(`/auth/login`, dto).then(
      ({ data }) => data
    );
  }

  static refreshToken() {
    return AtiraApi.post(`/auth/refresh-token`).then(({ data }) => data);
  }
}
